/** Shared row height for Toggle, SelectList and RadioSelector, so rows line up in a SettingsBlock */
export const SETTINGS_ROW_MIN_HEIGHT = 68;
